<template>
    <div class="objects__info block">
        <div class="account-info">
            <div class="account-info__item">
                <div class="account-info__label">Порядок расчета по договору:</div>
                <div class="account-info__value">
                    до 10 числа месяца, следующего за расчетным.
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    export default {
        name: 'account-paymentprocedure',
        props: {
            account: Object
        }
    }
</script>



// WEBPACK FOOTER //
// Scripts/app/fl/components/account-paymentprocedure.vue